/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-16 18:26:02
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Icon, Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DiamondAlertMajor, CircleTickMinor } from '@shopify/polaris-icons';

type Props = {
  active: boolean,
  deleting: boolean,
  title: string,
  content: string,
  subContent: string,
  handleCancel: () => void,
  handleConfirm: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class StatusModal extends Component<ComposedProps> {
  render() {
    const { active, loading = false, infoStatus = {} } = this.props;
    const { status = 'success', addonTitle, handleAction, hasContent = false } = infoStatus;

    const contentModal = hasContent
      ? {
          title: infoStatus.title,
          content: infoStatus.content,
          subContent: infoStatus.subContent,
          actionLabel: infoStatus.actionLabel,
          secondaryActionLabel: infoStatus.secondaryActionLabel
        }
      : this.getContentModal(status, addonTitle);

    const { title, content, subContent, actionLabel, secondaryActionLabel } = contentModal;

    const otherAction = [];
    if (secondaryActionLabel) {
      otherAction.push({
        content: secondaryActionLabel,
        onAction: this.secondaryAction
      });
    }
    return (
      <Modal
        open={active}
        onClose={() => this.handleCancel(status)}
        title={this.renderTitle(status, title)}
        primaryAction={{
          content: actionLabel,
          loading: loading,
          onAction: handleAction
        }}
        secondaryActions={otherAction}>
        <Modal.Section>
          <TextContainer>
            <p>{content}</p>
            <p style={{ marginTop: '0' }}>{subContent}</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  renderTitle = (status, content) => {
    return (
      <p className={`subscribe-status-modal--${status}`}>
        <Icon source={status === 'success' ? CircleTickMinor : DiamondAlertMajor} />
        {content}
      </p>
    );
  };

  handleCancel = status => {
    this.props.handleCancel(status);
  };

  secondaryAction = () => {
    this.props.secondaryAction();
  };

  getContentModal = (status, title) => {
    const { i18n } = this.props;
    if (status === 'success') {
      return {
        title: i18n.translate('AdminHTML.SubscriptionV3.SetupComplete.addonTitle', {
          addon: title ? i18n.translate(title) : ''
        }),
        content: i18n.translate('AdminHTML.SubscriptionV3.SetupComplete.addonContent', {
          addon: title ? i18n.translate(title) : ''
        }),
        subContent: '',
        actionLabel: i18n.translate('AdminHTML.Common.Action.close'),
        handleAction: this.handleCancel
      };
    }
    return {
      title: i18n.translate('AdminHTML.SubscriptionV3.SetupError.addonTitle'),
      content: i18n.translate('AdminHTML.SubscriptionV3.SetupError.addonContent'),
      subContent: '',
      actionLabel: i18n.translate('AdminHTML.SubscriptionV3.Actions.tryAgain'),
      secondaryActionLabel: i18n.translate('AdminHTML.SubscriptionV3.Actions.contactSupport')
    };
  };
}

export default withI18n()(StatusModal);
